module.exports = __webpack_public_path__ + "static/media/external-link.0ebe0a62.svg";